<template>
  <div class="mobile-corporate-culture">
    <!-- 固定Banner图 -->
    <div class="mobile-culture-banner">
      <img 
        :src="require('@/assets/aboutSailHero/img/banner_1.jpg')" 
        alt="企业文化"
        class="mobile-culture-banner__image"
      />
      <div class="mobile-culture-banner__overlay"></div>
      <div class="mobile-culture-banner__content">
        <h1 class="mobile-culture-banner__title">企业文化</h1>
        <p class="mobile-culture-banner__subtitle">CORPORATE CULTURE</p>
      </div>
    </div>

    <div class="mobile-culture-container">
      <!-- 三大理念 -->
      <section class="mobile-culture-principles">
        <div class="mobile-culture-principle">
          <div class="mobile-culture-principle__header">
            <div class="mobile-culture-principle__icon">🎯</div>
            <h3 class="mobile-culture-principle__title">企业愿景</h3>
          </div>
          <p class="mobile-culture-principle__content">
            做全球最专业的高端环境监测技术与服务提供商
          </p>
        </div>

        <div class="mobile-culture-principle">
          <div class="mobile-culture-principle__header">
            <div class="mobile-culture-principle__icon">🚀</div>
            <h3 class="mobile-culture-principle__title">企业使命</h3>
          </div>
          <p class="mobile-culture-principle__content">
            以先进的科技手段，满足公众对环境质量了解的渴望，促进社会对环境质量的管理和控制。
          </p>
        </div>

        <div class="mobile-culture-principle">
          <div class="mobile-culture-principle__header">
            <div class="mobile-culture-principle__icon">💡</div>
            <h3 class="mobile-culture-principle__title">企业理念</h3>
          </div>
          <p class="mobile-culture-principle__content">
            周审天地，关怀万物
          </p>
        </div>
      </section>

      <!-- 四大文化模块 -->
      <section class="mobile-culture-modules">
        <h2 class="mobile-culture-modules__title">文化天地</h2>
        <div class="mobile-culture-modules__grid">
          <div 
            v-for="(item, index) in cultureModules" 
            :key="item.id || index"
            class="mobile-culture-module"
            @click="openModuleDetail(item, index)"
          >
            <img 
              :src="item.fileUrl" 
              :alt="item.about_name"
              class="mobile-culture-module__bg"
            />
            <div class="mobile-culture-module__overlay"></div>
            <div class="mobile-culture-module__content">
              <h3 class="mobile-culture-module__title">{{ item.about_name }}</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileCorporateCulture",
  data() {
    return {
      employeeWorldList: [],    // 员工天地完整列表
      loading: false            // 加载状态
    };
  },
  computed: {
    // 前4条作为四大文化模块
    cultureModules() {
      return this.employeeWorldList.slice(0, 4);
    }
  },
  methods: {
    /**
     * 打开文化模块详情页
     * @param {Object} item - 员工天地数据项
     * @param {Number} index - 索引
     */
    openModuleDetail(item, index) {
      const _this = this;
      const list = _this.employeeWorldList;
      const listStr = JSON.stringify(list);
      
      const { href } = _this.$router.resolve({
        path: "/Client/CorporateCultureDetails",
        query: {
          id: item.id,
          bigTitle: "企业文化",
          modelitem: "企业文化",
          about_content: item.about_content,
          about_name: item.about_name,
          update_time: item.update_time,
          list: listStr,
          index: index,
          from: 'corporateCulture'
        }
      });
      // 使用 window.open 在新窗口中打开该 URL
      window.open(href, '_self');
    },

    /**
     * 获取员工天地列表
     */
    fetchEmployeeWorld() {
      const _this = this;
      _this.loading = true;

      _this.$api.post(
        "/Client/getEmployeeWorld",
        {
          pageSize: 100,
          pageIndex: 1
        },
        function (res) {
          _this.loading = false;
          if (res.code === "200") {
            _this.employeeWorldList = res.data || [];
          }
        },
        function (error) {
          _this.loading = false;
          console.error('获取员工天地列表失败:', error);
        }
      );
    }
  },

  mounted() {
    this.fetchEmployeeWorld();
  }
};
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/corporate-culture-mobile.css';
</style>

